var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReview1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 147,
    viewBox: "0 0 152 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.1448 76.5029C76.4823 72.4325 78.2594 68.6747 81.6286 66.2753C77.3186 64.7799 76.4755 60.3582 76.6966 56.2402C75.5124 61.1031 74.0528 65.7021 68.3574 66.1446C73.92 67.412 75.6914 70.9664 76.1448 76.5029Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8317 66.1337C78.3307 68.5252 76.489 72.3515 76.1448 76.5029C75.6914 70.9664 73.92 67.412 68.3574 66.1446C74.0528 65.7021 75.5124 61.1031 76.6966 56.2402C76.4743 60.3816 77.3283 64.8301 81.7024 66.3005",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.251 26.5645C43.5812 27.1324 43.8811 27.7386 44.2508 28.2816",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5127 33.9297C50.8384 39.7192 54.6453 45.3806 57.6062 51.3617",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.833 13.7598C60.1478 22.7237 62.57 32.1015 66.1583 40.9508",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8818 10.5117C77.0108 16.2012 77.1301 21.8907 77.2532 27.5777",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3105 34.5449C77.3762 35.5685 77.3896 36.5933 77.4486 37.6169",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4062 29.0017C91.1749 35.4081 86.9604 41.8061 82.8711 48.3088M103.046 17.0879C101.23 21.5344 98.0174 25.0508 95.407 29.0031",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2256 46.2566C102.495 43.6264 105.585 40.4372 108.484 37.4023",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.605 33.7091C113.824 32.5039 115.137 31.4021 116.357 30.1973",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.348 48.5586C119.78 53.6127 108.976 58.1129 98.6416 61.5235",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7147 60.4642C45.3578 54.9327 35.7362 50.0328 26.1562 44.9258",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6891 68.8398C50.7892 68.9054 48.8951 68.9819 47.0049 69.1819",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1497 69.5742C35.0918 69.8436 29.9599 69.7928 24.9268 70.3517",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1113 71.7852C101.385 71.8606 103.968 72.0085 106.227 72.4694",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113.563 74.1543C120.918 74.9267 128.077 76.9354 135.33 78.1914",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4389 75.6543C50.2612 84.1345 38.2766 91.3487 27.1309 99.8975",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1028 86.582C58.9247 93.628 55.5531 101.902 51.3223 109.5",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4922 127.359C62.4243 122.301 64.3006 117.326 65.7366 112.4C66.6699 109.198 67.2029 105.73 68.6998 102.723",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3936 96.8377C71.7981 95.8262 72.0552 94.7562 72.4949 93.7598",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4668 89.2285C83.4055 99.4817 85.452 110.016 88.1284 120.353",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9854 83.127C96.6957 88.3223 102.563 92.549 107.084 97.8645",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.77 103.602C114.953 104.975 116.329 106.276 117.65 107.516",
    stroke: "#FFC200",
    strokeWidth: 5.12308,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview1);
export default __webpack_public_path__ + "static/media/review1.6717afc7a500ffbd3f771c0307623701.svg";
export { ForwardRef as ReactComponent };